import React from 'react';
import { Anchor, Box, useDisclosure } from '@withjoy/joykit';
import { BurgerIconWrapper, PlainButtonWrapper } from './BurgerMenu.styles';
import { MenuList, MenuListProps } from './MenuList';
import { useOuterClick } from '@shared/utils/hooks/useOuterClick';
import { EventType } from '@graphql/generated';

export type BurgerMenuRenderProps = Readonly<{
  isOpen: boolean;
}>;

export type BurgerMenuProps = Readonly<{
  enableMobileFirst?: boolean;
  items: MenuListProps['items'];
  DrawerHeaderContent?: React.ReactNode;
  DrawerFooterContent?: React.ReactNode;
  drawerAnchor?: Anchor;
  useModernMenu?: boolean;
  eventInfo?: {
    eventType: EventType;
    eventHandle: string;
    eventId: string;
  };
  /**
   * Children can be either ReactNode or a render prop function.
   * Use render prop to access menu state (e.g., isOpen for styling).
   */
  children?: React.ReactNode | ((props: BurgerMenuRenderProps) => React.ReactNode);
}>;

export const BurgerMenu: React.FC<BurgerMenuProps> = ({ items, DrawerFooterContent, DrawerHeaderContent, drawerAnchor, eventInfo, children }) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const menuRef = useOuterClick(onToggle, isOpen);

  const isRenderProp = typeof children === 'function';
  const renderedChildren = isRenderProp ? children({ isOpen }) : children;

  return (
    <Box position="relative">
      {isRenderProp ? (
        <PlainButtonWrapper onClick={() => onToggle()}>{renderedChildren}</PlainButtonWrapper>
      ) : (
        <BurgerIconWrapper
          isActive={isOpen}
          onClick={() => onToggle()}
        >
          {renderedChildren}
        </BurgerIconWrapper>
      )}
      <MenuList
        menuRef={menuRef}
        isOpen={isOpen}
        onClose={onClose}
        items={items}
        DrawerFooterContent={DrawerFooterContent}
        DrawerHeaderContent={DrawerHeaderContent}
        drawerAnchor={drawerAnchor}
        eventInfo={eventInfo}
      />
    </Box>
  );
};
